// extracted by mini-css-extract-plugin
export default {"daysOff":"NonShippingDays_daysOff__bxRmG","select":"NonShippingDays_select__OJlBK"};